<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div class="bg-white rounded-lg p-6 mb-4">
      <h2 class="font-bold text-xl mb-4">FiBu-Exporte</h2>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label>Export-Typ</label>
          <select v-model="exportArt" class="border-2 border-gray-200 px-2 py-1 w-full">
            <option value="Buchungsstapel">Buchungsstapel</option>
            <option value="Stammdaten">Stammdaten</option>
            <option value="Buchungen">Buchungen</option>
            <option value="SEPA-Mandate">SEPA-Mandate</option>
            <option value="RFID-Fehler">RFID-Fehler</option>
          </select>
        </div>
        <div>
          <label>Format</label>
          <select v-model="format" class="border-2 border-gray-200 px-2 py-1 w-full">
            <option value="csv">CSV</option>
            <option value="xlsx">XLSX</option>
          </select>
        </div>
        <div>
          <label>Projekt</label>
          <select v-model="project" class="border-2 border-gray-200 px-2 py-1 w-full">
            <option v-for="p in exportProjects" :key="p.value" :value="p.value">{{ p.label }}</option>
          </select>
        </div>
        <div>
          <label>Stichtag</label>
          <input type="date" v-model="targetDate" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
        <div>
          <label>Erstellt ab</label>
          <input type="date" v-model="startdate" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
        <div>
          <label>Erstellt bis</label>
          <input type="date" v-model="enddate" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
        <div>
          <label>Erste FibuNummer</label>
          <input type="number" v-model="startnumber" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
        <div>
          <label>Letzte FibuNummer</label>
          <input type="number" v-model="endnumber" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
      </div>
      <div class="mt-4 flex gap-6">
        <div class="flex items-center gap-2">
          <input id="fibuAllNotExported" type="checkbox" class="small" v-model="allNotExported">
          <label for="fibuAllNotExported">Alle nicht exportierten Datensätze (nur Stammdaten)</label>
        </div>
        <div class="flex items-center gap-2" v-if="exportArt === 'Buchungsstapel'">
          <input id="fibuKostenBeschreibung" type="checkbox" class="small" v-model="mitKostenBeschreibung">
          <label for="fibuKostenBeschreibung">Mit Kostenbeschreibung</label>
        </div>
      </div>
      <div class="mt-6 text-center">
        <button class="w-96" @click="runExport" :disabled="exporting">
          {{ exporting ? 'Exportiere...' : 'Export starten' }}
        </button>
      </div>
      <div v-if="exportError" class="mt-4 text-red-600 text-center">{{ exportError }}</div>
      <div v-if="exportSuccess" class="mt-4 text-green-600 text-center">Export erfolgreich heruntergeladen.</div>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "FibuExports",
  data() {
    return {
      exportArt: "Buchungsstapel",
      format: "csv",
      project: "Alle",
      exportProjects: [],
      targetDate: "",
      startdate: new Date().toISOString().slice(0, 10),
      enddate: new Date().toISOString().slice(0, 10),
      startnumber: 0,
      endnumber: 999999,
      allNotExported: false,
      mitKostenBeschreibung: false,
      exporting: false,
      exportError: null,
      exportSuccess: false,
    };
  },
  methods: {
    loadOptions() {
      API.getExportOptions((r, status) => {
        if (status === 200) {
          this.exportProjects = r.projects;
        }
      });
    },
    runExport() {
      this.exporting = true;
      this.exportError = null;
      this.exportSuccess = false;
      API.runExport({
        exportArt: this.exportArt,
        format: this.format,
        project: this.project,
        targetDate: this.targetDate,
        startdate: this.startdate,
        enddate: this.enddate,
        startnumber: parseInt(this.startnumber),
        endnumber: parseInt(this.endnumber),
        allNotExported: this.allNotExported,
        mitKostenBeschreibung: this.mitKostenBeschreibung,
      }, (success, status) => {
        this.exporting = false;
        if (success && status === 200) {
          this.exportSuccess = true;
        } else {
          this.exportError = "Export fehlgeschlagen (Status " + status + ")";
        }
      });
    },
  },
  created() {
    this.loadOptions();
  },
};
</script>

<style scoped>
label {
  display: block;
  font-weight: bold;
  margin-bottom: 4px;
}
</style>
